<template>
    <div>
        <b-table
            :data="accounts"
            :columns="columns"
            :sticy-header="true"
            :height=750
            >
        </b-table>
    </div>
</template>
<script>
export default {
    name: 'AdminAccountsTable',

    props: ['accounts'],

    computed: {
        columns(){
            return[
                {
                    field: 'userEmail',
                    label: 'Email',
                    width: '150',
                    searchable: true,
                },
                {
                    field: 'username',
                    label: 'Username',
                    width: '150',
                    searchable: true,
                }
            ]
        }
    }
}
</script>